<template>
    <div class="gap-lg col-span-12 flex flex-col">
        <h1 v-if="organizationStore.usersOrganization">{{ organizationStore.usersOrganization?.name }}'s dashboard</h1>

        <GenericInfo show="all" />

        <section v-if="showIncidents" name="Latest incidents" class="gap-sm lg:gap-md flex flex-col">
            <div class="flex items-center justify-between">
                <h2>Active & Open incidents</h2>
                <button class="gap-xs flex items-center" @click="$router.push({ name: 'incidents' })">
                    <p class="font-matter font-normal">Incident overview</p>
                    <i class="i-arrow-right-blue block" />
                </button>
            </div>
            <IncidentOverview
                :filters="{
                    statuses: ['Open', 'Active'],
                }"
                :show-total="true"
                :item-count="5"
                :enable-polling="true"
                :disable-pagination="true"
            />
        </section>

        <section v-if="showTickets" name="Latest org requests" class="gap-md flex flex-col">
            <div class="flex items-center justify-between">
                <h2>Latest tickets</h2>
                <button class="gap-xs flex items-center" @click="$router.push({ name: 'support' })">
                    <p class="font-matter font-normal">Ticket overview</p>
                    <i class="i-arrow-right-blue block" />
                </button>
            </div>
            <RequestOverview
                :item-count="requestCount"
                :show-filters="false"
                :no-result-message="'You have not created any requests yet'"
                :click-show-more="true"
                :enable-polling="true"
            />
        </section>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import RequestOverview from '@/components/support/request-overview.vue';
import IncidentOverview from '@/components/incident/IncidentOverview.vue';
import { useOrganizationStore } from '@/stores/organization';
import GenericInfo from '@/components/generic-info.vue';

const organizationStore = useOrganizationStore();
const usersOrganization = computed(() => organizationStore.usersOrganization);
const requestCount = ref(5);

const ticketRoles = ['user-ticket-viewer', 'org-ticket-viewer', 'user-ticket-creator'];
const incidentRoles = ['user-incident-viewer', 'org-incident-viewer', 'user-incident-creator'];

const showIncidents = computed(() => {
    if (!usersOrganization.value) return false;

    const userRoles = organizationStore.currentUserRoles.map((r) => r.name);
    const hasUserRole = incidentRoles.some((role) => userRoles.includes(role));
    if (hasUserRole) return true;

    if (organizationStore.isOrgAdmin) {
        const orgRoles = organizationStore.currentOrgRoles.map((r) => r.name);
        return incidentRoles.some((role) => orgRoles.includes(role));
    }

    return false;
});

const showTickets = computed(() => {
    if (!usersOrganization.value) return false;

    const userRoles = organizationStore.currentUserRoles.map((r) => r.name);
    const hasUserRole = ticketRoles.some((role) => userRoles.includes(role));
    if (hasUserRole) return true;

    if (organizationStore.isOrgAdmin) {
        const orgRoles = organizationStore.currentOrgRoles.map((r) => r.name);
        return ticketRoles.some((role) => orgRoles.includes(role));
    }

    return false;
});
</script>
